import AuthorizationWrapper from "../AuthorizationWrapper";
import { Grid, MenuItem, Select, Typography } from "@material-ui/core";
import React from "react";
import withIntl from "../../utils/withIntl";

export const currencies = [
  { key: "eur", symbol: "€" },
  { key: "ang", symbol: "ƒ" },
];

function CurrencySetting(props) {
  return (
    <AuthorizationWrapper
      permission={props.authenticationName}
      child={(write) => {
        return (
          <Grid container alignItems={"center"} spacing={1}>
            <Grid item xs={4}>
              <Select
                style={{ width: "95%" }}
                disabled={!write}
                value={props.setting.value}
                onChange={(e) => props.onChange(e.target.value)}
              >
                {currencies.map((currency) => {
                  return (
                    <MenuItem value={currency.key}>
                      {props.intl.formatMessage({ id: currency.key })} {currency.symbol}
                    </MenuItem>
                  );
                })}
              </Select>
            </Grid>
            <Grid item xs={8}>
              <Typography>{props.label}</Typography>
            </Grid>
          </Grid>
        );
      }}
    />
  );
}

export default withIntl(CurrencySetting);
